import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  forkJoin,
  map,
  Observable,
  of,
  throwError,
} from 'rxjs';
import { InfoCategory } from '../../shared/models/app/info-category';
import { SubCategoriesEnum } from '../../shared/models/app/info-enum';
import { PageResponse } from '../../shared/models/page/page-response';
import { Product } from '../../shared/models/product/product';
import ProductFilter from '../../shared/models/product/product-filter';
import { AppInfoService } from '../app-info/app-info.service';
import { HttpService } from '../http/http.service';

export interface ProductSearch {
  route: string;
  search: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  public static readonly SKU_PRODUCT_BANDO_DOUBLE = '12130';
  public static readonly SKU_PRODUCT_BANDO_ROLO = '20194';
  public static readonly SKU_PRODUCT_MOTOR = '19632';

  public searchProductsSubCategory$ = new BehaviorSubject<ProductSearch>({
    route: '',
    search: '',
  });

  private valueMotor = 1284;
  private valueBandoDouble = 26;
  private valueBandoRolo = 77;
  public _categorires: InfoCategory[] = [];

  constructor(
    private appInfoService: AppInfoService,
    private httpService: HttpService
  ) {}

  getSearchProductsSubCategory() {
    return this.searchProductsSubCategory$.asObservable();
  }

  setSearchProductsSubCategory(value: ProductSearch) {
    this.searchProductsSubCategory$.next(value);
  }

  public products(filter: ProductFilter): Observable<PageResponse> {
    return forkJoin({
      res: this.httpService.post(`v2/product/pageable/list/`, filter),
      categories: of(this.getCategories()),
    }).pipe(
      map(({ res, categories }) => {
        const response = new PageResponse();

        if (res?.content) {
          const products = res.content.map((productBanco: any) => {
            const newProduct = new Product();
            newProduct.fromJson(productBanco, categories);
            return newProduct;
          });

          response.content = products;
          response.totalElements = res.totalElements;
        }

        return response;
      }),
      catchError((error: any) => {
        const msg =
          error?.error?.message ||
          error?.error?.error ||
          'Ocorreu um erro ao buscar os produtos.';
        return throwError(() => new Error(msg));
      })
    );
  }

  public get(sku: string): Observable<Product> {
    const product = new Product();

    return this.httpService.get(`product/${sku}`).pipe(
      map((res: any) => {
        if (res) {
          product.fromJson(res, this.getCategories());
        }
        return product;
      }),
      catchError((error: any) => {
        const msg =
          error?.error?.message ||
          error?.error?.error ||
          'Ocorreu um erro ao buscar esse produto. Tente novamente em alguns minutos!';
        return throwError(() => new Error(msg));
      })
    );
  }

  getValueMotor(): number {
    return this.valueMotor;
  }

  getValueBandoDouble(): number {
    return this.valueBandoDouble;
  }

  getValueBandoRolo(): number {
    return this.valueBandoRolo;
  }

  getValueTotalBando(width: number, model: string): number {
    return this.isPersianaDouble(model)
      ? this.getValueTotalBandoDouble(width)
      : this.getValueTotalBandoRolo(width);
  }

  getValueTotalBandoDouble(width: number): number {
    if (width < 1) {
      width = 1;
    }
    const valueBando: number = this.getValueBandoDouble();
    let valueTotal: number = width * valueBando;
    return valueTotal;
  }

  getValueTotalBandoRolo(width: number): number {
    if (width < 1) {
      width = 1;
    }
    const valueBando: number = this.getValueBandoRolo();
    let valueTotal: number = width * valueBando;
    return valueTotal;
  }

  /*async getValueMotorBando() {
    if (this.valueMotor === 0) {
      try {
        const productMotor = await this.get(ProductsService.SKU_PRODUCT_MOTOR);
        this.valueMotor = productMotor?.value || 1000;
      } catch (error) {
        this.valueMotor = 1000;
      }
    }

    if (this.valueBandoDouble === 0) {
      try {
        const productBando = await this.get(
          ProductsService.SKU_PRODUCT_BANDO_DOUBLE
        );
        this.valueBandoDouble = productBando?.value || 30;
      } catch (error) {
        this.valueBandoDouble = 30;
      }
    }

    if (this.valueBandoRolo === 0) {
      try {
        const productBando = await this.get(
          ProductsService.SKU_PRODUCT_BANDO_ROLO
        );
        this.valueBandoRolo = productBando?.value || 30;
      } catch (error) {
        this.valueBandoRolo = 30;
      }
    }
  }*/

  isPersianaRolo(model: string) {
    return model === SubCategoriesEnum.ROLO;
  }

  isPersianaDouble(model: string) {
    return model === SubCategoriesEnum.DOUBLE_VISION;
  }

  getCategories() {
    if (this._categorires?.length > 0) {
      return this._categorires;
    } else {
      this._categorires = this.appInfoService.getCategories();
      return this._categorires;
    }
  }

  getSquareMetter(customHeight: number, customWidth: number) {
    let squareMeter = customHeight * customWidth;
    if (squareMeter < 1) {
      squareMeter = 1;
    }
    return squareMeter;
  }
}
